/** Shared lodging accent (calendar + Tour Planner). */
export const LODGING_ACCENT_COLOR = '#7c6cdd';

export function stopKeyForVenue(venueId) {
  return `venue:${String(venueId || '').trim()}`;
}

export function stopKeyForPin(pinId) {
  return `pin:${String(pinId || '').trim()}`;
}

export function isDayLodgingVenue(day, venueId) {
  return String(day?.lodgingVenueId || '').trim() === String(venueId || '').trim();
}

export function lodgingCardStyle(isDarkMode) {
  return {
    borderColor: LODGING_ACCENT_COLOR,
    backgroundColor: isDarkMode ? 'rgba(124,108,221,0.12)' : 'rgba(124,108,221,0.08)',
  };
}
